import styled from 'styled-components';

export const Label = styled.p`
    color: red;
    z-index: 1;
    text-align: end;
    font-size: 0.9rem;
    position: relative;
`;
